module.exports = __webpack_public_path__ + "img/7B7E82_343536_A0B1C8_44444C-256px.8672a90a.png";